import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/disparos")({
  beforeLoad: () => {
    throw redirect({ to: "/admin/marketing/newsletter", replace: true });
  },
});
